import styled from "styled-components";

export const ToggleLabel = styled.label`
display: flex;
align-items: center;
gap: 10px;
cursor: pointer;
height: 35px;
width:60px;
margin-right:${props=>props.marginRight?props.marginRight:0};
margin-left:${props=>props.marginLeft?props.marginLeft:0};
border-radius:${props=>props.cookies?"5px":""};
box-shadow: ${props=>props.cookies?"rgba(0, 0, 0, 0.25) 0px 2px 4px 0px":""};
padding:3px;
`;

export const ToggleSwitch = styled.div`
position: relative;
width: 48px;
height: 24px;
background: #BBB4A9;
border-radius: 32px;
padding: 4px;
transition: 300ms all;

&:before {
  transition: 300ms all;
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  top: 50%;
  left: 0px;
  background: ${props=>props.disabled?"#BBB4A9":"white"};
  transform: translate(0, -50%);
  margin-left:2px;
}
`;

export const ToggleInput = styled.input`
    opacity: 0;
    position: absolute;
    display: none;

    &:checked + ${ToggleSwitch} {
      background: #FF6B00;
  
      &:before {
        transform: translate(28px, -50%);
        margin-left:0px;
      }
    }
`;